<template>
  <div>
    <warehouse-handling-tabs></warehouse-handling-tabs>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :items="items"
            :cols="cols"
            :canSubmit="canSubmit"
            :canDelete="canDelete"
            :is-editing.sync="isEditing"
            :showListBtn="false"
            :show-navigation-btns="false"
            list-export-base-url="reports/lists/inventoryClerk"
            :list_filters="{}"
            :exportParams="{id: item.id}"
            @click:row="setItem"
            @clearForm="clearForm"
            @submit="submit"
            @delete="deleteItem"

        >
          <template>
            <v-row>
              <v-col cols="12" md="6">
                <div id="inventory-clerk-first-name">
                  <v-text-field class="rounded-lg" label=" نام" v-model="item.first_name" :disabled="!isEditing"/>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div id="inventory-clerk-last-name">
                  <v-text-field class="rounded-lg" label=" نام خانوادگی"
                                v-model="item.last_name" :disabled="!isEditing"/>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div id="inventory-clerk-explanation">
                  <v-text-field class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing"/>
                </div>
              </v-col>
            </v-row>
          </template>
        </m-form>
      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import GetUserApi from "@/views/panel/user/getUserApi";
import CompanyMixin from "@/views/panel/company/mixin";
import WarehouseHandlingTabs from "@/views/panel/warehouseHandling/WarehouseHandlingTabs";


export default {
  name: "InventoryClerkForm",
  components: {WarehouseHandlingTabs},
  mixins: [MFormMixin, GetUserApi, CompanyMixin],
  data() {
    return {
      cols: [
        {
          text: "نام",
          value: "first_name",
          filterable: false,
        },
        {
          text: "نام خانوادگی",
          value: "last_name",
          filterable: false,
        },
        {
          text: "توضیحات",
          value: "explanation",
          filterable: false,
        },
      ],

      baseUrl: "wares/inventory_clerk",
      permissionBasename: "inventory_clerk",
      items: [],
    };
  },
  computed: {
    title(){
      return this.setDocumentTitle('تعریف انبارگردان')
    },
    createUrl() {
      return `${this.baseUrl}/`;
    },
    updateUrl() {
      return this.item.id && `${this.baseUrl}/${this.item.id}/`;
    },
    deleteUrl() {
      return this.item.id && `${this.baseUrl}/${this.item.id}/`;
    },
  },
  updated() {
  },
  methods: {
    getInventoryClerks(callback) {
      this.request({
        url: this.endpoint(`wares/inventory_clerk/`),
        method: "get",
        success: (data) => {
          callback(data)
        },
      });
    },
    getData() {
      this.getInventoryClerks((data) => (this.items = data));
    },
  }
  }
</script>

<style scoped lang="scss"></style>

